import React from "react";
import "./Header.scss";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../../app/slice/authSlice";
import Iconify from "../../../../components/ui/iconify/Iconify";

function Header() {
  const { isLogedin, loginName, isAuthenticated, userName, name } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  return (
    <div className="header-section d-flex justify-content-end">
      <div className="user-name">
        <Iconify
          icon="mdi:user-circle"
          altText="Logout Icon"
          className="user-icon"
        />
        {/* Admin */}
        {/* {userName || loginName} */}
        {name || ''}
      </div>
      <button
        className="btn btn-link"
        onClick={() => {
          dispatch(logout());
        }}
      >
        <span className="logout-text">Logout</span>
      </button>
    </div>
  );
}
export default Header;
